(function () {
    "use strict";

    angular
        .module("app")
        .directive("multiSelectDropdown", ["$document", multiSelectDropdown]);

    function multiSelectDropdown($document) {
        return {
            restrict: "E",
            link: function (scope, element) {
                scope.hidden = true;

                $document.on("click", function (e) {
                    var isChild = $(element).has(event.target).length > 0;
                    var isSelf = element[0] === event.target;
                    var isInside = isChild || isSelf;

                    if (!isInside) {
                        scope.hidden = true;
                        scope.$apply();
                    }
                });

                scope.toggleDrop = function (e) {
                    scope.hidden = !scope.hidden;
                };

                scope.onChange = function () {

                    var summary = "";
                    var selected = _.filter(scope.options, function (i) { return i[scope.selectedProp] === true; });

                    if (selected.length > 0) {
                        summary = selected[0][scope.textProp];
                    }

                    _.each(_.rest(selected, 1), function (i) { summary = summary + ", " + i[scope.textProp] });

                    scope.summary = summary;
                };
            },
            scope: { options: "=", textProp: "@", selectedProp: "@" },
            templateUrl: templateUrl("app/directives/multiSelectDropdown.directive.html")
        };
    }
})();

